import { useSelector } from "react-redux";
import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";
import { capitalize } from "../../../../../services";

const useStyles = makeStyles(() => ({
  heading: {
    display: "flex",
    marginBottom: 50,
  },
  paper: {
    fontWeight: 400,
    color: COLORS.blackShade,
    marginTop: 8,
  },
  box: {
    display: "flex",
  },
  rightDiv: {
    "& .MuiGrid-justify-content-xs-center": {
      justifyContent: "flex-start",
    },
  },
  boldData: {
    fontWeight: 600,
  },
  leftDiv: {
    "& .MuiGrid-spacing-xs-3": {
      width: 350,
    },
  },
  hr: {
    width: 545,
    marginTop: 50,
    marginBottom: 50,
    marginLeft: 0,
  },
}));

const RentalRevenue = ({ data, onDataChange }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;

  const infoFields = [
    {
      key: "total_termination_income",
      title: "Total termination income",
      suffix: currencySymbol,
    },
    {
      key: "total_late_fees",
      title: "Total late fees",
      suffix: currencySymbol,
    },
    {
      key: "total_parking_others",
      title: "Total parking and others",
      suffix: currencySymbol,
    },
    {
      key: "other_revenues",
      title: "Other revenue from services provided in property",
      suffix: currencySymbol,
    },
    {
      key: "rental_revenues_growth",
      title: "Rental revenue-rental growth",
      suffix: "%/year",
    },
  ];

  return (
    <Box>
      <Box className={classes.heading}>
        <Typography variant="h1">Tenancy data - </Typography>&nbsp;
        <Typography style={{ fontSize: 27 }}> Rental Revenue</Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs>
          <Typography variant="h5" className={classes.paper}>
            Potential rental revenue
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Box width={600}>
            <TextInput
              style={{ background: COLORS.white, width: "180px" }}
              type="number"
              value={data.potencial_rental_revenue}
              onChange={(v) => onDataChange("potencial_rental_revenue", v)}
              containerStyle={classes.box}
              suffix={`${currencySymbol}/${capitalize(user?.unit_system)}`}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Effective gross rental revenue
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Box style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.boldData}>
              XXX{" "}
            </Typography>
            &nbsp;
            <Typography variant="h5">
              {currencySymbol}/{capitalize(user?.unit_system)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs>
          <Typography variant="h5" className={classes.paper}>
            Total Potential revenue
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Box width={600}>
            <TextInput
              style={{ background: COLORS.white, width: "180px" }}
              type="number"
              value={data.total_potential_revenue}
              onChange={(v) => onDataChange("total_potential_revenue", v)}
              containerStyle={classes.box}
              suffix={currencySymbol}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Total effective gross rental revenue
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Box style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.boldData}>
              {currencySymbol} XXX
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <hr className={classes.hr} />
      {infoFields.map((value, i) => {
        return (
          <Grid container spacing={3} key={i} className={classes.leftDiv}>
            <Grid item xs>
              <Typography variant="h5" className={classes.paper}>
                {value.title}
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.rightDiv}>
              <Box width={600}>
                <TextInput
                  style={{ background: COLORS.white, width: "180px" }}
                  type="number"
                  value={data[value.key]}
                  onChange={(v) => onDataChange(value.key, v)}
                  containerStyle={classes.box}
                  suffix={value.suffix ? value.suffix : ""}
                />
              </Box>
            </Grid>
          </Grid>
        );
      })}
      <Grid container spacing={3} style={{ paddingBottom: 90 }}>
        <Grid item xs>
          <Typography variant="h5" className={classes.boldData}>
            Total rental revenue
          </Typography>
        </Grid>
        <Grid item xs={8} className={classes.rightDiv}>
          <Typography variant="h5" className={classes.boldData}>
            {currencySymbol} XXX
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RentalRevenue;
